import React from "react"
import LinkButton from "../linkButton"
import styles from "./LinkRow.module.scss"

const LinkRow = ({ links, path }) => {
  if (!links.length) return null

  function getLink(to) {
    // Remove the extra tidligere-prosjekter/ in the url
    // Return absolute url.
    if (path.endsWith("/tidligere-prosjekter/")) {
      return `/prosjektene/${to}`
    }
    return to
  }

  return (
    <div className={styles.linkRow}>
      {links
        .filter((x) => x?.slug?.current)
        .map((link, index) => (
          <LinkButton
            to={getLink(link.slug.current)}
            inline
            key={`subpage-${index}`}
          >
            {link.title}
          </LinkButton>
        ))}
    </div>
  )
}

export default LinkRow
